import { formatDateForDisplay } from '../../accessibility-trends-chart/helpers/dateFormatHelpers';
import { CHART_TEXT } from '../constants';

/**
 * Creates tooltip HTML content for accessibility stacked chart
 */
export const createTooltipContent = (name: string, dateString: string, value: number): string => {
	const date = formatDateForDisplay(dateString);
	const label = `${name} issues`;
	return `<div class="tooltip-label">${label}: <span class="tooltip-value">${value}</span></div><div class="tooltip-date">${CHART_TEXT.TOOLTIP.DATE_LABEL} ${date}</div>`;
};
